export default {
  title: "Conecta tu wallet para continuar",
  description:
    "No hemos podido conectar automáticamente la wallet asociada a tu cuenta. Conéctala manualmente para continuar.",
  button: "Conectar wallet",
  disconnect: "Volver a login",
  disconnectModal: {
    title: "Cerrar sesión",
    message: "Vas a cerrar la sesión con el correo",
    confirm: "Sí, continuar",
    cancel: "Cancelar",
  },
}
